/** Annie AbilitySpec seed kit. */
export const ANNIE_ABILITY_DEFS = [
  {
    id: 'annie_q',
    champKey: 'annie',
    slot: 'Q',
    name: 'Disintegrate',
    targeting: 'targeted',
    range: 625,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 4,
    manaCost: 60,
    vfxId: 'annie_q',
    status: 'wired'
  },
  {
    id: 'annie_w',
    champKey: 'annie',
    slot: 'W',
    name: 'Incinerate',
    targeting: 'skillshot_cone',
    range: 600,
    castTime: 0.25,
    travelSpeed: 1100,
    width: null,
    radius: 14,
    cooldown: 7,
    manaCost: 70,
    vfxId: 'annie_w',
    projectilesCount: 5,
    coneAngleRad: 0.55,
    status: 'wired'
  },
  {
    id: 'annie_e',
    champKey: 'annie',
    slot: 'E',
    name: 'Molten Shield',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 10,
    manaCost: 60,
    vfxId: 'annie_e',
    status: 'wired'
  },
  {
    id: 'annie_r',
    champKey: 'annie',
    slot: 'R',
    name: 'Summon: Tibbers',
    targeting: 'ground_aoe',
    range: 600,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 250,
    cooldown: 130,
    manaCost: 100,
    vfxId: 'annie_r',
    status: 'wired'
  }
];
